<template>
  <div class="fshr-tripCardSkeleton">
    <div class="fshr-tripCardSkeleton__imgWrapper">
      <LoadingSkeleton />
    </div>
    <div class="fshr-tripCardSkeleton__content">
      <div class="fshr-tripCardSkeleton__title">
        <LoadingSkeleton />
      </div>
      <div class="fshr-tripCardSkeleton__rating">
        <LoadingSkeleton />
      </div>
      <div class="fshr-tripCardSkeleton__location">
        <LoadingSkeleton />
      </div>
      <div class="fshr-tripCardSkeleton__dateDistance">
        <LoadingSkeleton />
      </div>
      <div class="fshr-tripCardSkeleton__services">
        <LoadingSkeleton />
      </div>
      <div class="fshr-tripCardSkeleton__priceWrapper">
        <LoadingSkeleton />
      </div>
      <div class="fshr-tripCardSkeleton__actions">
        <div class="fshr-tripCardSkeleton__actionsLink">
          <div class="fshr-tripCardSkeleton__actionsLinkItem">
            <LoadingSkeleton />
          </div>
          <div class="fshr-tripCardSkeleton__actionsLinkItemBottom">
            <LoadingSkeleton />
          </div>
        </div>
        <div class="fshr-tripCardSkeleton__actionsButton">
          <LoadingSkeleton />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSkeleton from "./common/LoadingSkeleton.vue";

export default {
  name: "TripCardLoading",
  components: {
    LoadingSkeleton,
  },
};
</script>
